import { render } from "./ziva.html?vue&type=template&id=0f25adba&external"
import script from "./ziva.js?vue&type=script&lang=js&external"
export * from "./ziva.js?vue&type=script&lang=js&external"

import "./ziva.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__